module.exports = __webpack_public_path__ + "static/media/FrameProfileTestResult.2c17825b.svg";